// extracted by mini-css-extract-plugin
module.exports = {"blockCopy":"block-copy-module--blockCopy--1AgzT"};